import React, { useState } from 'react'
import UsageStep from './UsageStep/UsageStep.jsx'
import WelcomeModal from './WelcomeModal/WelcomeModal.jsx'
import { ReactComponent as HeaderSVG } from '@/assets/svg/modals/header-wave-1.svg'
import BoxesIntroStep from './BoxesIntroStep/BoxesIntroStep.jsx'
import CreateLabelExplanationStep from './CreateLabelExplanationStep/CreateLabelExplanationStep.jsx'

const WelcomeModalRouter = (props) => {
  const [currentStep, setCurrentStep] = useState('welcome-step')
  const [usage, setUsage] = useState()

  function getWelcomeStep () {
    setCurrentStep('welcome-step')
  }

  function getBoxesIntroStep () {
    setCurrentStep('boxes-intro')
  }

  function getLabelsCreationStep () {
    setCurrentStep('labels-creation-step')
  }

  function getHowToCreateLabelsStep () {
    setCurrentStep('how-to-create-labels-step')
  }

  // eslint-disable-next-line
  function getMessageSendingStep () {
    setCurrentStep('boxes-sending-message-step')
  }

  function getCurrentStepComponent () {
    if (currentStep === 'welcome-step') {
      return (
        <WelcomeModal closeModal={props.closeModal} continueOnboarding={getBoxesIntroStep} usage={usage} setUsage={setUsage}/>
      )
    } else if (currentStep === 'boxes-intro') {
      return (
        <BoxesIntroStep closeModal={props.closeModal} goToPreviousStep={getWelcomeStep} usage={usage} setUsage={setUsage} continueOnboarding={getLabelsCreationStep}/>
      )
    } else if (currentStep === 'labels-creation-step') {
      return (
        <UsageStep closeModal={props.closeModal} goToPreviousStep={getBoxesIntroStep} usage={usage} setUsage={setUsage} continueOnboarding={getHowToCreateLabelsStep}/>
      )
    } else if (currentStep === 'how-to-create-labels-step') {
      //
      return <CreateLabelExplanationStep closeModal={props.closeModal} goToPreviousStep={getLabelsCreationStep} usage={usage} setUsage={setUsage}/>
    }/* else if (currentStep === 'write-first-message-step') {
      return (
        <WriteFirstMessageStep closeModal={props.closeModal} getUsageStep={getUsageStep} usage={usage} setUsage={setUsage}/>
      )
    } */
  }

  return (
    <>
      <div className='header'><HeaderSVG style={{ marginTop: '-20px', width: '100%' }} /></div>
      <div className='content' style={{ zIndex: 10 }}>{getCurrentStepComponent()}</div>
    </>
  )
}

export default WelcomeModalRouter
